{
    "navbar": {
        "help_center": "Centro de ayuda",
        "share_idea": "Compartir una idea",
        "logout": "Desconexión"
    },
    "languages": {
        "title": "Idiomas",
        "explanation": "Puedes cambiar el idioma actual de la interfaz por uno de los siguientes",
        "de": "Alemán",
        "fr": "Francés",
        "en": "Inglés",
        "it": "Italiano",
        "es": "Español"
    },
    "form": {
        "submit": "Validar",
        "cancel": "Cancelar",
        "errors": {
            "required": "Campo obligatorio"
        }
    },
    "menu": {
        "request_manager": {
            "title": "Request Manager",
            "pipeline": "Pipeline",
            "todo": "To Do",
            "inbox": "Inbox",
            "message_templates": "Message Templates"
        },
        "offer_manager": {
            "title": "Offer Manager",
            "itineraries": "Itinerarios en Línea"
        },
        "cash_manager": {
            "title": "Cash Manager",
            "accounting": "Contabilidad"
        },
        "insights": {
            "title": "Insights",
            "statistics": "Estadísticas",
            "customer_satisfaction": "Satisfacción del Cliente",
            "better_trip_index": "Better Trip Index"
        },
        "tipi": {
            "title": "Trip Planner",
            "library": "Biblioteca"
        },
        "tools": {
            "title": "Resources Center",
            "partner_connect": "Partner Connect"
        },
        "agency_manager": {
            "title": "Agency Manager",
            "main_contacts": "Contactos Principales",
            "active_accounts": "Cuentas Activas",
            "agency_capacity": "Capacidad de la agencia",
            "legal_information": "Información legal"
        }
    }
}
